import React, { useState } from 'react'
import { Box, Link } from '@material-ui/core'

import { Dropzone } from 'Components/Form/Dropzone'
import { Modal } from 'Components/Modal'
import { ModalBody } from 'Components/Modal/ModalBody'
import { ModalFooter } from 'Components/Modal/ModalFooter'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { ModalTitle } from 'Components/Modal/ModalTitle'

import SubmitButton from '../../../../Components/Form/SubmitButton/index'
import { processCsvFile } from '../../../../Utils/Misc'
import useGraphQLFetch from 'Utils/Hooks/useGraphQLFetch'
import { getCampaigns as getCampaignsGQL } from '../../../../Module/graphQL'

import {
  formatFlyerCodesData,
  formatFlyerCodesGQLData,
  downloadFlyerCodesTemplate,
  validateCsvFlyerCodesData,
} from '../util'
import {
  STATUS_CAMPAIGN_ENUM_ACTIVE,
  STATUS_CAMPAIGN_ENUM_DRAFT,
} from '../../../../shared/constants'
import ConfirmationModalBody from '../ConfirmationModalBody'

const AddCsvFlyerCodesModal = props => {
  const [flyersData, setFlyersData] = useState(null)
  const { csvModalCancel, showReduxModal, hideReduxModal } = props

  const fetchArgs = {
    statuses: [STATUS_CAMPAIGN_ENUM_DRAFT, STATUS_CAMPAIGN_ENUM_ACTIVE],
  }
  const { data = {}, isLoaded } = useGraphQLFetch({
    fetchFn: getCampaignsGQL,
    mapResponse: formatFlyerCodesGQLData,
    defaultFetchArgs: fetchArgs,
  })
  const onError = err => {
    showReduxModal({
      title: 'Upload failed',
      children: `${err}`,
      confirmLabel: `OK`,
      hideCancel: true,
    })
  }
  const modalConfirmHandler = async () => {
    if (flyersData) {
      showReduxModal({
        title: 'Confirmation needed',
        children: (
          <ConfirmationModalBody
            flyersData={flyersData}
            hideReduxModal={hideReduxModal}
            modalCancel={csvModalCancel}
          />
        ),
        confirmLabel: `Confirm`,
        hideButtons: true,
      })
    }
  }

  const onLoadFile = async entryFiles => {
    try {
      if (entryFiles) {
        const csvData = await processCsvFile(entryFiles[0])

        if (!csvData || !csvData.data) return
        validateCsvFlyerCodesData(csvData.data, data)

        const formatSendData = formatFlyerCodesData(csvData.data, data)

        setFlyersData(formatSendData)
      }
    } catch (err) {
      onError(err)
      console.error(err)
    }
  }

  return (
    <Modal show={true}>
      <ModalHeader>
        <ModalTitle>Import Flyer Codes</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Box display="flex" justifyContent="center">
          <div>
            You can upload codes to campaigns with status Draft or Active
          </div>
        </Box>
        <Box display="flex" alignItems="center" flexDirection="column">
          <Link onClick={downloadFlyerCodesTemplate}>
            Download the csv template
          </Link>
          {isLoaded ? (
            <Dropzone
              mainLabel="Flyer Codes File"
              input={{
                value: '',
                onChange: onLoadFile,
              }}
            />
          ) : (
            'Preparing data, please wait...'
          )}
        </Box>
      </ModalBody>
      <ModalFooter>
        <SubmitButton
          value="cancel"
          onClick={csvModalCancel}
          disabled={false}
        />
        <SubmitButton
          value={'Confirm'}
          onClick={modalConfirmHandler}
          disabled={!isLoaded}
        />
      </ModalFooter>
    </Modal>
  )
}

export default AddCsvFlyerCodesModal
